import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useBankAccountReasonService from '../../../app/services/hooks/useBankAccountReasonService';

interface Props {
    bankAccountReasonId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const BankAccountReasonSwitchChange = ({ bankAccountReasonId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeBankAccountReason, fetchingActiveBankAccountReason } = useBankAccountReasonService();

    const active = (value: boolean) => {
        setChecked(value);

        activeBankAccountReason(bankAccountReasonId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={bankAccountReasonId} callback={active} />;
};

export default BankAccountReasonSwitchChange;
